import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';

@Component({
	selector: 'app-dynamic-form-input-time',
	standalone: false,
	templateUrl: './dynamic-form-input-time.component.html',
	styleUrl: './dynamic-form-input-time.component.scss'
})
export class DynamicFormInputTimeComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	toControlKey = AbstractDynamicForm.toControlKey;
}
